import React from "react";
import ReactDOM from "react-dom";
import { alpha, Box, Typography } from "@mui/material";
import { ImageFolderSmallOn } from "@mzc-cloudplex/icons";

/**
 * 폴더 드래그 시 setDragImage 소스로 쓰는 프리뷰.
 * 폴더명은 dragstart 핸들러가 label 요소 textContent로 직접 주입한다
 * (state 세팅은 dragstart 시점의 스냅샷 캡처에 리렌더가 못 맞춤).
 */
const FolderDragPreview = React.forwardRef((_props, ref) =>
    ReactDOM.createPortal(
        <Box
            ref={ref}
            sx={(theme) => ({
                position: "absolute",
                top: 0,
                left: 0,
                transform: "translateX(-9999px)",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                boxSizing: "border-box",
                width: "240px",
                height: "40px",
                paddingLeft: "24px",
                paddingRight: "8px",
                backgroundColor: theme.palette.common.white,
                border: `1px solid ${alpha(theme.palette.primary.main, 0.6)}`,
                borderRadius: "4px",
                filter: "drop-shadow(0 3px 3px rgba(0, 0, 0, 0.16))",
                "& svg": {
                    flexShrink: 0,
                },
            })}
        >
            <ImageFolderSmallOn width={16} height={16} />
            <Typography
                component="span"
                noWrap
                className="folder-drag-preview-label"
                sx={{ fontSize: "14px", color: "text.primary" }}
            />
        </Box>,
        document.body,
    ),
);

FolderDragPreview.displayName = "FolderDragPreview";

export default FolderDragPreview;
